export const DASHBOARD_TOUR_TARGET_ATTRIBUTE = 'data-dashboard-tour';

export const dashboardTourTarget = (target: string): string =>
  `[${DASHBOARD_TOUR_TARGET_ATTRIBUTE}="${target}"]`;
